@if (stateService.community() === 'middleton') {
  <app-listing-details-cta-middleton (lppClicked)="lppPostMessage()" />
} @else {
  <app-listing-details-cta-villages (lppClicked)="lppPostMessage()" />
}
